import React, { useEffect } from 'react';
import { ErrorBoundary } from 'react-error-boundary';

import { ErrorBoundaryFallback } from '@components/ErrorBoundaryFallback';
import { RoleGuard } from '@components/Guards';

import { RoleName } from '@constants/role_name';

import { useCuration } from '@hooks/useCuration';

import Patients from '@views/Clients/Main';

export default function PatientsMainPage() {
  const { reset } = useCuration();

  useEffect(() => {
    reset();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <RoleGuard roles={[RoleName.Practitioner]}>
      <ErrorBoundary FallbackComponent={ErrorBoundaryFallback}>
        <Patients />
      </ErrorBoundary>
    </RoleGuard>
  );
}
